import { useTranslation } from 'react-i18next';
import { Dialog, DialogDescription, DialogHeader, DialogTitle } from 'components';
import {
  CancelButton,
  ConfirmRevokeButton,
  ObjectionDialogContent,
  ObjectionDialogFooter,
} from './RecordingObjectionDialog.styles';

interface RecordingObjectionRevokeDialogProps {
  isRevoking: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const RecordingObjectionRevokeDialog = ({
  isRevoking,
  onConfirm,
  onClose,
}: RecordingObjectionRevokeDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <ObjectionDialogContent data-ph-no-autocapture>
        <DialogHeader>
          <DialogTitle>{t('recording.objection.revokeTitle')}</DialogTitle>
          <DialogDescription>{t('recording.objection.revokeDescription')}</DialogDescription>
        </DialogHeader>
        <ObjectionDialogFooter>
          <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
          <ConfirmRevokeButton onClick={onConfirm} disabled={isRevoking}>
            {t('recording.objection.revokeConfirm')}
          </ConfirmRevokeButton>
        </ObjectionDialogFooter>
      </ObjectionDialogContent>
    </Dialog>
  );
};
